// extracted by mini-css-extract-plugin
export default {"wrapper":"body_wrapper__hqkFS","content":"body_content__J89ZW"};